export default "__VITE_ASSET__Bec1iFU5__"